module.exports = __webpack_public_path__ + "img/graph1.a2bb6b51.png";